/**
 * FAQ accordion (inc/faq.php).
 *
 * Markup from Elementor: .faq-list > .faq-item > [.faq-q heading, .faq-a box]. Each question gets a
 * button; the first answer starts open, the rest closed. Opening one closes the others in the same
 * list. Heights animate over 420ms; with reduced motion they switch at once.
 */
( function () {
	'use strict';

	var DURATION = 420;
	var EASE = 'cubic-bezier(.2,.7,.2,1)';
	var reduce = window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	var count = 0;

	function animateItem( item, from, to, done ) {
		if ( item.faqAnim ) {
			item.faqAnim.cancel();
		}

		if ( reduce || ! item.animate || from === to ) {
			done();
			return;
		}

		item.classList.add( 'is-anim' );
		item.faqAnim = item.animate(
			{ height: [ from + 'px', to + 'px' ] },
			{ duration: DURATION, easing: EASE }
		);
		item.faqAnim.onfinish = function () {
			item.faqAnim = null;
			item.classList.remove( 'is-anim' );
			done();
		};
		item.faqAnim.oncancel = function () {
			item.faqAnim = null;
			item.classList.remove( 'is-anim' );
		};
	}

	function setOpen( entry, open ) {
		var item = entry.item;
		var answer = entry.answer;
		var from = item.offsetHeight;

		entry.open = open;
		entry.button.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
		item.classList.toggle( 'is-open', open );

		if ( open ) {
			answer.hidden = false;
			animateItem( item, from, item.offsetHeight, function () {} );
			return;
		}

		animateItem( item, from, from - answer.offsetHeight, function () {
			if ( ! entry.open ) {
				answer.hidden = true;
			}
		} );
	}

	function build( list ) {
		var entries = [];

		Array.prototype.forEach.call( list.querySelectorAll( '.faq-item' ), function ( item ) {
			var question = item.querySelector( '.faq-q' );
			var answer = item.querySelector( '.faq-a' );

			if ( ! question || ! answer || question.querySelector( '.faq-btn' ) ) {
				return;
			}

			count++;

			var button = document.createElement( 'button' );
			var label = document.createElement( 'span' );
			var mark = document.createElement( 'span' );

			button.type = 'button';
			button.className = 'faq-btn';
			button.id = 'faq-q-' + count;
			label.className = 'faq-btn-text';
			mark.className = 'faq-pm';
			mark.setAttribute( 'aria-hidden', 'true' );

			while ( question.firstChild ) {
				label.appendChild( question.firstChild );
			}
			button.appendChild( label );
			button.appendChild( mark );
			question.appendChild( button );

			answer.id = answer.id || 'faq-a-' + count;
			answer.setAttribute( 'role', 'region' );
			answer.setAttribute( 'aria-labelledby', button.id );
			button.setAttribute( 'aria-controls', answer.id );

			var entry = { item: item, button: button, answer: answer, open: false };
			entries.push( entry );

			button.addEventListener( 'click', function () {
				if ( entry.open ) {
					setOpen( entry, false );
					return;
				}

				entries.forEach( function ( other ) {
					if ( other !== entry && other.open ) {
						setOpen( other, false );
					}
				} );
				setOpen( entry, true );
			} );
		} );

		entries.forEach( function ( entry, index ) {
			var open = 0 === index;
			entry.open = open;
			entry.answer.hidden = ! open;
			entry.button.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			entry.item.classList.toggle( 'is-open', open );
		} );

		list.classList.add( 'faq-ready' );
	}

	function init() {
		Array.prototype.forEach.call( document.querySelectorAll( '.faq-list' ), build );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
